require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./soutenance-de-thses-et-leons-inaugurales-1-12-2.json") })
        }
      }, "path---soutenance-de-thses-et-leons-inaugurales-1-12-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---soutenance-de-thses-et-leons-inaugurales-1-12-2!./.cache/json/soutenance-de-thses-et-leons-inaugurales-1-12-2.json
// module id = 573
// module chunks = 231608221292675